import { lazy, Suspense } from "react";

import { Skeleton } from "@mui/material";
import { IgBasePrimitives } from "@intelligems/ig-design-tokens/constants";

const MuxPlayer = lazy(async () => import("@mux/mux-player-react"));

const PLAYER_FILL_SX = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
};

const PLAYER_FILL_STYLE = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
} as const;

type ModuleDemoVideoProps = Readonly<{
  autoPlay?: boolean;
  playbackId: string;
  title: string;
}>;

export const ModuleDemoVideo = ({
  autoPlay = false,
  playbackId,
  title,
}: ModuleDemoVideoProps) => (
  <Suspense
    fallback={
      <Skeleton animation="wave" variant="rectangular" sx={PLAYER_FILL_SX} />
    }
  >
    <MuxPlayer
      accentColor={IgBasePrimitives[500]}
      autoPlay={autoPlay}
      metadata={{ video_title: title }}
      playbackId={playbackId}
      style={PLAYER_FILL_STYLE}
      title={title}
    />
  </Suspense>
);
